import { Avatar, CollapseCard } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';

import { Score, ScoreIcon, ScoreIconStyle } from 'fable/ScoreIcon';

import '../../../styles/cards.less';

type EffectiveCustomization = {
  look_and_feel?: ScoreIconStyle;
  sender_email?: string;
  reply_to_email?: string;
  delay?: number;
  subject?: string;
  body?: string;
  rating_question?: string;
  thank_you_message?: string;
  comment_question?: string;
  placeholder_text?: string;
  button_text?: string;
};

export type FeedbackT = {
  rating_id?: string;
  conversation_id?: number;
  user_id?: string;
  agent_id?: string;
  channel?: string;
  status?: string;
  type?: string;
  score?: Score;
  comment?: string;
  created_at?: string;
  modified_at?: string;
  scheduled_at?: string;
  offered_at?: string;
  rated_at?: string;
  language?: string;
  effective_customization?: EffectiveCustomization; // for email csat
  csat_look_and_feel?: ScoreIconStyle; // for chat csat
};

type PropsT = {
  isOpen: boolean;
  isMinimized?: boolean;
  csid: string;
  feedback?: Array<FeedbackT>;
  onToggle: () => void;
  requestFeedback: ({ csid }: { csid: string }) => void;
};

const DEFAULT_CSAT_LOOK_AND_FEEL = 'numbers';

export class FeedbackCard extends PureComponent<PropsT> {
  componentDidMount() {
    const { requestFeedback, csid } = this.props;
    requestFeedback({ csid });
  }

  componentDidUpdate(prevProps: PropsT) {
    const { requestFeedback, csid } = this.props;

    if (prevProps.csid !== csid) {
      requestFeedback({ csid });
    }
  }

  render() {
    const { isOpen, isMinimized = false, onToggle, feedback } = this.props;

    if (!feedback) {
      return null;
    }

    const feedbackWithScore = feedback.filter(
      ({ score }) => typeof score === 'number' && score > 0 && score < 6,
    );

    if (feedbackWithScore.length === 0) {
      return null;
    }

    const avatar = <Avatar icon="smile" />;

    if (isMinimized) {
      return <div className="icon-holder">{avatar}</div>;
    }

    const average =
      feedbackWithScore.reduce((acc, { score }) => acc + (score || 0), 0) /
      feedbackWithScore.length;

    const explanation = `${average.toFixed(1).replace(/.0$/, '')} out of 5`;

    // get latest rated feedback
    const {
      score,
      comment,
      csat_look_and_feel: csatLookAndFeel,
      effective_customization: effectiveCustomization,
    } = feedback.slice().sort((a, b) => {
      if (a?.rated_at && b?.rated_at) {
        return -a.rated_at.localeCompare(b.rated_at);
      }
      return 1;
    })[0];

    const csatType =
      effectiveCustomization?.look_and_feel ||
      csatLookAndFeel ||
      DEFAULT_CSAT_LOOK_AND_FEEL;

    return (
      <CollapseCard
        onToggle={onToggle}
        isOpen={isOpen}
        className="feedback-card"
      >
        <CollapseCard.Header avatar={avatar} title="Satisfaction Rating">
          Satisfaction Rating
        </CollapseCard.Header>
        <CollapseCard.Content>
          <CollapseCard.Line label="Average Rating Score:">
            {explanation}
          </CollapseCard.Line>
          <CollapseCard.Line
            className="feedback-latest"
            label="Latest Rating Score:"
          >
            {score && <ScoreIcon score={score} style={csatType} />}
          </CollapseCard.Line>
          <div className="feedback-comment">{comment}</div>
        </CollapseCard.Content>
      </CollapseCard>
    );
  }
}
